import * as yup from 'yup';

export const schema = yup.object().shape({
    Id: yup.string().required('Support ticket Id is not set'),
    Reference : yup.string().required('Order reference is not assigend')
})